const validate = (value, args) => {
  let regex = /^(\d{8,9})$/
  if (!regex.test(value)) {
    return false
  }

  return true
}

export default {
  validate,
  getMessage: (field, args) => {
    return 'The number must not contain the prefix zero and consists of 8 or 9 digits'
  }
}
